export const STATUS_OPTIONS = [
    {
      label: "Working",
      value: "Working",
    },
    {
      label: "Pulled Out",
      value: "Pulled Out",
    },
    {
      label: "Transferred",
      value: "Transferred",
    },
    {
      label: "Disposed",
      value: "Disposed",
    },
    {
        label: "For Repair",
        value: "For Repair",
    },
    {
        label: "For Calibration",
        value: "For Calibration",
    },
    {
        label: "For Maintenance",
        value: "For Maintenance",
    },
    {
        label: "Offline",
        value: "Offline",
    }
]